import { Component, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subject, Observable, Subscription } from 'rxjs';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { GameDayModel } from '../../../models/gameday-model';
import { GameDayRootReducerState } from '../../../state/root.state';
import { FilterBySealedBid } from '../../../state/data/actions';
import {
  getGamedayDealState,
  getGamedayFiltersState
} from '../../../state/data/reducer';

@Component({
  selector: 'muni-gameday-sealed-bid',
  templateUrl: './sealed-bid.template.html',
  styleUrls: ['./sealed-bid.styles.scss']
})
export class SealedBidComponent implements OnDestroy {
  public readonly change: Subject<boolean> = new Subject<boolean>();

  public readonly isShown: Observable<boolean> = this.store.pipe(
    select(getGamedayDealState),
    filter((deal: GameDayModel.Deal) => !!deal),
    map((deal: GameDayModel.Deal) =>
      deal.maturities.some(
        (maturity: GameDayModel.Maturity) => maturity.isSealedBid
      )
    ),
    distinctUntilChanged()
  );

  public readonly checked: Observable<boolean> = this.store.pipe(
    select(getGamedayFiltersState),
    map(({ isSealedBid }) => !isSealedBid),
    distinctUntilChanged()
  );

  private readonly changeSubscription: Subscription = this.change
    .asObservable()
    .subscribe((selected: boolean) =>
      this.store.dispatch(new FilterBySealedBid(!selected))
    );

  constructor(private store: Store<GameDayRootReducerState>) {}

  public ngOnDestroy(): void {
    this.changeSubscription.unsubscribe();
  }
}
